<template>

<div class="nested" v-if="item.nested.length" :class="{'is-active': true}">

	<app-view-sheet-item 
        :is-condensed="true" 
        :is-sticky="isSticky" 
        :item="subitem" 
        :fields="fields"
        :filter="filter"
        :grid="grid"
        :key="subitem.id" 
        v-for="subitem in nested" 
    >

	</app-view-sheet-item>

</div>

</template>

<script>

export default {

	props: ['item', 'fields', 'filter', 'grid', 'isSticky'],

	computed: {

		nested: function() {

			var nested = []

			this.$_.each(this.item.nested, function(id) {

				nested.push(this.$store.getters['page/' + this.filter + '/nested/associated/collection'][id])

			}.bind(this))

			nested = this.$_.sortBy(nested, function(item) {

				return item.game.name

			})

			return nested

		}

	}

}

</script>

<style scoped>

.nested {
	padding-bottom: 3px;
	margin-top: -4px;
	display: none;
}

.nested.is-active {
	display: block;
}

.nested-horizontal {
	position: absolute;
	height: 1px;
	width: 16px;
	left: 8px;
	top: 16px;
	border-bottom: 1px dotted #ccc;
}

.nested-vertical {
	position: absolute;
	border-left: 1px dotted #ccc;
	top: -4px;
	bottom: 20px;
	left: 8px;
	width: 1px;
}

.is-mobile .nested-vertical {
	top: -28px;
	bottom: 48px;
}

</style>